import { useEffect } from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useShallow } from "zustand/react/shallow";

import { useOrderStore } from "~/stores/use-order-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderSplitForm from "./order-split-form";

export default function OrderSplitDialog() {
  const { splitDialogOpen, setSplitDialogOpen, currentOrder } = useOrderStore(
    useShallow((state) => ({
      splitDialogOpen: state.splitDialogOpen,
      setSplitDialogOpen: state.setSplitDialogOpen,
      currentOrder: state.currentOrder,
    })),
  );

  const handleDialog = (open: boolean) => {
    if (open === false) {
      setSplitDialogOpen(false);
    }
    setSplitDialogOpen(open);
  };

  return (
    <Dialog open={splitDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>Split order</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-0">
          {currentOrder && (
            <OrderSplitForm
              onClose={() => {
                handleDialog(false);
              }}
              order={currentOrder}
            />
          )}
        </ScrollArea>
        <DialogFooter>
          <Button type="submit" form="split-order-form" className="w-full">
            Split
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
